<template>
    <div class="contents">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-main">
                        <h4 class="text-capitalize fw-500 breadcrumb-title">Broadcast ke User</h4>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-8">
                    <div class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                        <form v-on:submit.prevent="sendBroadcast">
                            <div class="form-group">
                                <label>Penerima</label>
                                <select v-model="form.recipients" class="form-control" @change="previewRecipients" required>
                                    <option value="all">Semua User</option>
                                    <option value="active">User Aktif (langganan belum expired)</option>
                                    <option value="inactive">User Tidak Aktif (langganan expired)</option>
                                </select>
                            </div>

                            <div class="form-group">
                                <label>Channel Pengiriman</label>
                                <div class="row">
                                    <div class="col-md-4">
                                        <label class="payment-method-option d-flex align-items-center p-2 border rounded" :class="{'border-primary bg-light': form.channel === 'email'}" style="cursor:pointer">
                                            <input type="radio" value="email" v-model="form.channel" class="mr-2">
                                            <div>
                                                <i class="fas fa-envelope text-primary"></i>
                                                <strong> Email</strong>
                                            </div>
                                        </label>
                                    </div>
                                    <div class="col-md-4">
                                        <label class="payment-method-option d-flex align-items-center p-2 border rounded" :class="{'border-success bg-light': form.channel === 'whatsapp'}" style="cursor:pointer">
                                            <input type="radio" value="whatsapp" v-model="form.channel" class="mr-2">
                                            <div>
                                                <i class="fab fa-whatsapp text-success"></i>
                                                <strong> WhatsApp</strong>
                                            </div>
                                        </label>
                                    </div>
                                    <div class="col-md-4">
                                        <label class="payment-method-option d-flex align-items-center p-2 border rounded" :class="{'border-warning bg-light': form.channel === 'both'}" style="cursor:pointer">
                                            <input type="radio" value="both" v-model="form.channel" class="mr-2">
                                            <div>
                                                <i class="fas fa-bullhorn text-warning"></i>
                                                <strong> Keduanya</strong>
                                            </div>
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group" v-if="form.channel === 'email' || form.channel === 'both'">
                                <label>Subject Email</label>
                                <input v-model="form.subject" type="text" class="form-control" :required="form.channel !== 'whatsapp'" placeholder="Judul email yang akan dikirim">
                            </div>

                            <div class="form-group">
                                <label>Pesan</label>
                                <textarea v-model="form.message" class="form-control" rows="8" required placeholder="Isi pesan broadcast..."></textarea>
                                <small class="text-muted">Pesan dikirim via email (format rapi) dan WhatsApp (subject dicetak tebal di atas pesan).</small>
                            </div>

                            <button type="submit" class="btn btn-primary btn-block" :disabled="isSending">
                                <span v-if="isSending">Mengirim...</span>
                                <span v-else><i class="fas fa-paper-plane mr-1"></i> Kirim Broadcast ke {{ totalRecipients }} User</span>
                            </button>
                        </form>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                        <h5 class="mb-3"><i class="fas fa-info-circle text-primary mr-1"></i> Ringkasan</h5>
                        <div class="info-box mb-3" style="padding:15px;background:#f8f9fa;border-radius:8px;">
                            <label class="info-label" style="font-size:12px;color:#6c757d;text-transform:uppercase;font-weight:600;display:block;margin-bottom:5px;">Total Penerima</label>
                            <div style="font-size:28px;font-weight:700;color:#6366f1;">{{ totalRecipients }}</div>
                        </div>
                        <div class="info-box mb-3" style="padding:15px;background:#f8f9fa;border-radius:8px;">
                            <label class="info-label" style="font-size:12px;color:#6c757d;text-transform:uppercase;font-weight:600;display:block;margin-bottom:5px;">Channel</label>
                            <div style="font-size:14px;font-weight:600;">
                                <span v-if="form.channel === 'email'"><i class="fas fa-envelope text-primary"></i> Email (ZeptoMail API)</span>
                                <span v-else-if="form.channel === 'whatsapp'"><i class="fab fa-whatsapp text-success"></i> WhatsApp (api.whacenter.com)</span>
                                <span v-else><i class="fas fa-bullhorn text-warning"></i> Email + WhatsApp</span>
                            </div>
                        </div>
                        <div class="info-box mb-3" style="padding:15px;background:#f8f9fa;border-radius:8px;">
                            <label class="info-label" style="font-size:12px;color:#6c757d;text-transform:uppercase;font-weight:600;display:block;margin-bottom:5px;">Filter</label>
                            <div style="font-size:14px;font-weight:600;">
                                {{ recipientsLabel }}
                            </div>
                        </div>
                        <div class="alert alert-warning small mb-0">
                            <i class="fas fa-exclamation-triangle mr-1"></i>
                            Broadcast dikirim di background dengan concurrency 5. Hasil lengkap tercatat di log server.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: {
                    recipients: "all",
                    channel: "email",
                    subject: "",
                    message: "",
                },
                totalRecipients: 0,
                isSending: false,
            };
        },
        computed: {
            recipientsLabel() {
                switch (this.form.recipients) {
                    case "active": return "User Aktif";
                    case "inactive": return "User Tidak Aktif";
                    default: return "Semua User";
                }
            }
        },
        mounted() {
            this.previewRecipients();
        },
        methods: {
            async previewRecipients() {
                try {
                    let response = await this.$store.dispatch('admin_broadcast_preview', { recipients: this.form.recipients });
                    this.totalRecipients = response.data.data.total_recipients || 0;
                } catch (err) {
                    console.log(err);
                }
            },
            async sendBroadcast() {
                if (!this.form.message) {
                    this.$toast.error("Pesan tidak boleh kosong");
                    return;
                }
                if ((this.form.channel === "email" || this.form.channel === "both") && !this.form.subject) {
                    this.$toast.error("Subject email tidak boleh kosong");
                    return;
                }

                let confirmMsg = `Kirim broadcast ke ${this.totalRecipients} user via ${this.recipientsLabel} menggunakan ${this.form.channel === 'both' ? 'Email + WhatsApp' : this.form.channel === 'email' ? 'Email' : 'WhatsApp'}?`;
                if (!confirm(confirmMsg)) return;

                this.isSending = true;
                try {
                    let response = await this.$store.dispatch('admin_broadcast_send', this.form);
                    this.$toast.success(response.data.message);
                } catch (err) {
                    this.$toast.error(err.response?.data?.message || "Gagal mengirim broadcast");
                } finally {
                    this.isSending = false;
                }
            },
        },
    };
</script>

<style scoped>
    .info-box {
        padding: 15px;
        background: #f8f9fa;
        border-radius: 8px;
    }

    .info-label {
        font-size: 12px;
        color: #6c757d;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        margin-bottom: 5px;
        display: block;
        font-weight: 600;
    }

    .payment-method-option {
        display: block;
    }
</style>
